import React, { Component } from "react";
import { Link } from "react-router-dom";

class BookDetailsContent extends Component {
  render() {
    return (
      <section className="book-details pt-150 pb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="book-details-content">
                <h2 className="mt-3 mb-4">
                  Ali & Friends: Ali Learns to Breathe
                </h2>

                <div className="book-info mb-4">
                  <div className="info-item mb-3">
                    <strong>Author:</strong> Ricky Yakobus Kota & Diah Galuh Sarimbit
                  </div>
                  <div className="info-item mb-3">
                    <strong>Pages:</strong> 23
                  </div>
                  <div className="info-item mb-3">
                    <strong>Language:</strong> English
                  </div>
                  <div className="info-item mb-3">
                    <strong>Format:</strong> eBook (PDF download), Audiobook
                  </div>
                </div>

                <div className="book-description mb-4">
                  <h4 className="mb-3">Description</h4>
                  <p>
                    When 7-year-old Ali gets angry, he kicks and throws
                    whatever’s nearby. But one day, after losing a game of
                    engklek, he meets Grandma Mary, a gentle 92-year-old
                    Australian woman who’s just moved to his Indonesian
                    neighborhood.
                  </p>
                  <p>
                    With simple words “Breathe in, breathe out”, Grandma Mary
                    helps Ali and his friends learn to calm down, talk about
                    their feelings, and care for one another. A warm story about
                    friendship, empathy, and the power of breathing, bridging
                    cultures and generations.
                  </p>
                </div>

                <div className="book-features mb-4">
                  <h4 className="mb-3">Themes</h4>
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      <i className="fa fa-check text-color"></i> Emotional
                      regulation and mindfullness for children
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-check text-color"></i>{" "}
                      Intergenerational friendship and dementia awareness
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-check text-color"></i> Cross-cultural
                      understanding between Indonesia and Australia
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-check text-color"></i> The power of
                      play, empathy, and community
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="book-details-img text-center">
                <img
                  src="/assets/images/banner/book.png"
                  alt="Book Cover"
                  className="img-fluid"
                  style={{ maxWidth: "400px" }}
                />
              </div>

              {/* Improved actions layout: two centered rows aligned with the cover */}
              <div
                className="book-actions mt-4 text-center"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Link
                    to="/read-book"
                    className="btn btn-main"
                    style={{ minWidth: 160 }}
                  >
                    Read Book
                  </Link>

                  <a
                    href="/assets/books/book.pdf"
                    download
                    className="btn btn-main"
                    style={{ minWidth: 160 }}
                  >
                    Download PDF
                  </a>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <a
                    href="/presentation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-main"
                    style={{ minWidth: 160 }}
                  >
                    Watch Audiobook
                  </a>

                  <Link
                    to="/"
                    className="btn btn-outline btn-back-home"
                    style={{ minWidth: 160 }}
                  >
                    Back to Home
                  </Link>
                </div>

                {/* btn-back-home styles are now in global CSS (src/index.css) */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BookDetailsContent;
